import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "label"];

  connect() {
    this.inputElement = this.inputTarget;
    if (!this.inputElement) return;

    // Initialize with current value
    this.formatValue();
  }

  focus() {
    // Remove formatting on focus for easier editing
    const value = this.inputElement.value;
    if (value && value.includes(".")) {
      // Remove trailing zeros and decimal if it's .00
      const num = parseFloat(value);
      if (num % 1 === 0) {
        this.inputElement.value = num.toString();
      } else {
        this.inputElement.value = num.toString();
      }
    }
  }

  blur() {
    this.formatValue();
  }

  input() {
    // Real-time validation and formatting
    this.validateAndFormat();
  }

  keydown(event) {
    // Allow: backspace, delete, tab, escape, enter, home, end, left, right, up, down
    if (
      [8, 9, 27, 13, 46, 35, 36, 37, 38, 39, 40].indexOf(event.keyCode) !==
        -1 ||
      // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
      (event.ctrlKey === true &&
        [65, 67, 86, 88].indexOf(event.keyCode) !== -1) ||
      // Allow: Ctrl+Shift+A, Ctrl+Shift+C, Ctrl+Shift+V, Ctrl+Shift+X
      (event.ctrlKey === true &&
        event.shiftKey === true &&
        [65, 67, 86, 88].indexOf(event.keyCode) !== -1)
    ) {
      return;
    }

    // Ensure that it is a number and stop the keypress
    if (
      (event.shiftKey || event.keyCode < 48 || event.keyCode > 57) &&
      (event.keyCode < 96 || event.keyCode > 105) &&
      event.keyCode !== 190
    ) {
      // Allow decimal point
      event.preventDefault();
    }

    // Only allow one decimal point
    if (event.keyCode === 190 && this.inputElement.value.includes(".")) {
      event.preventDefault();
    }
  }

  validateAndFormat() {
    let value = this.inputElement.value;

    // Remove any non-numeric characters except decimal point
    value = value.replace(/[^0-9.]/g, "");

    // Ensure only one decimal point
    const parts = value.split(".");
    if (parts.length > 2) {
      value = parts[0] + "." + parts.slice(1).join("");
    }

    // Limit to 2 decimal places
    if (parts.length === 2 && parts[1].length > 2) {
      value = parts[0] + "." + parts[1].substring(0, 2);
    }

    // Prevent values like 25.999999999
    if (parts.length === 2 && parts[1].length === 2) {
      const num = parseFloat(value);
      if (!isNaN(num)) {
        value = num.toFixed(2);
      }
    }

    this.inputElement.value = value;
  }

  formatValue() {
    const value = this.inputElement.value;
    if (!value) return;

    const num = parseFloat(value);
    if (isNaN(num)) {
      this.inputElement.value = "";
      return;
    }

    // Format to 2 decimal places
    this.inputElement.value = num.toFixed(2);
  }
}

